import React, { Component } from "react"
// import { Redirect } from 'react-router-dom'
// import Rating from './rating'
import CircularProgress from "@material-ui/core/CircularProgress"
import { API } from "../../../API"

export default class NavigateToPreviewProfile extends Component {
  componentDidMount = () => {
    const data = window.location.search.substring(1).split("data=")[1]
    // console.log("link " + data)
    var decodedData = decodeURIComponent(data).replace("'", "")
    // booking_id field in mongodb booking data might not be used anymore
    var { teacher_id, booking_ids, date } = JSON.parse(decodedData)

    // const userId =
    //   ratingData.firstName[0].toUpperCase() +
    //   ratingData.firstName.slice(1) +
    //   "_" +
    //   ratingData.lastName[0].toUpperCase()

      API.getUserSafeDataById(teacher_id)
      .then((res) => {
        const path = {
          pathname: "/temporary/rating",
          state: {
            teacher: res.data.user,
            // booking_id field in mongodb booking data might not be used anymore
            booking_ids: booking_ids,
            date: date,
          },
        }
        this.props.history.push(path)
      })
      .catch((err) => {
        console.log('err', err)
        return (
          <div>
            <p>ID not found</p>
          </div>
        )
      })
  }

  render = () => (
    <div className="justify-center justify">
      <CircularProgress color="inherit" />
    </div>
  )
}
